const currencies = [
  { code: 'STcoin', symbol: '', emoji: '' },
  { code: 'JPY', symbol: '¥', emoji: 'Japanese Yen' },
];

export default currencies;
